goog.provide("shadow.js.shim.module$$mui$material$RadioGroup$default");
shadow.js.shim.module$$mui$material$RadioGroup$default = shadow.js.shim.module$$mui$material$RadioGroup.default;
